import { Box, Button, Grid, Typography } from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import { OrganizationsClient, EmailWhitelistResponseDTO } from '../generated/ApiClient'
import MUIDataTable from "mui-datatables";
import { Link as RouterLink } from 'react-router-dom';
import { actionCreators as snackbar } from '../store/AlertSnackbarStore'
import { useDispatch } from 'react-redux';
import { insertIf, tableOptions as options, utcToLocal } from '../common/Shared'
import { GlobalEditor, useIsUserInRoles } from '../hooks/useIsUserInRoles';
import { DateTime } from 'luxon';
interface EmailsTableData {
    email: string;
    created: DateTime;
}

type props = {
    organizationId: string;
}

export default function EmailList(props: props) {
    const [emailData, setEmailData] = useState<EmailsTableData[]>([]);
    const orgId = props.organizationId
    const tableOptions = {
        ...options,
        selectableRowsHideCheckboxes: true
    }
    const dispatch = useDispatch()
    const isGlobalUser = useIsUserInRoles(GlobalEditor)
    const handleRemove = async (email: string) => {
        try {
            await new OrganizationsClient().removeEmail(orgId, email);
            setEmailData(emailData.filter(x => x.email != email))
            dispatch(snackbar.addMessage({ title: "Success", message: `Email successfully removed`, alertType: 'success' }))
        }
        catch (error) {
            dispatch(snackbar.addError(error, undefined, 'Error writing to the database'));
        }
    }

    const columns = [
        {
            name: "email",
            label: "Email",
            options: {
                sort: true,
                filter: true
            }
        },
        {
            name: "created",
            label: "Created",
            options: {
                sort: true,
                filter: true,
                customBodyRenderLite: (dataIndex: number) => {
                    return <Typography>{emailData[dataIndex].created.toLocaleString(DateTime.DATETIME_MED)}</Typography>
                }
            }
        },
        ...insertIf(isGlobalUser, {
            name: 'removeButton',
            label: 'Remove',
            options: {
                sort: false,
                filter: false,
                customBodyRenderLite: (dataIndex: number) => {
                    return <Button onClick={() => handleRemove(emailData[dataIndex].email)} variant='contained' size='small'>Remove</Button>
                }
            }
        })
    ];

    function toTableData(emailData: EmailWhitelistResponseDTO) {
        return {
            email: emailData.email || "",
            created: utcToLocal(emailData.created)
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const emails = await new OrganizationsClient().getAllWhitelistedEmails(orgId);
                const tableData = emails.map(toTableData)
                setEmailData(tableData);
            }
            catch (error) {
                dispatch(snackbar.addError(error, undefined, 'Error fetching '));
            }
        }
        fetchData();
    }, [orgId])

    return (
        <>
            {isGlobalUser &&
                <Grid container item direction='column' spacing={2} alignItems='flex-end'>
                    <Box my={2}>
                        <Button component={RouterLink} variant='contained' color='primary' size='medium' to={`/organizations/${orgId}/emails/create`}>+ Add</Button>
                    </Box>
                </Grid>}
            <MUIDataTable
                title={""}
                data={emailData}
                columns={columns}
                options={tableOptions}
            />
        </>
    )
}
